/**
 * Theme preference: light | dark | system (follow OS).
 * Stored per user as u:{userId}:theme when logged in; FOUC also mirrors to `theme`.
 */
(function () {
    'use strict';

    const STORAGE_KEY = 'theme';

    function systemPrefersDark() {
        return !!( window.matchMedia && window.matchMedia( '(prefers-color-scheme: dark)' ).matches );
    }

    function resolveEffectiveTheme( preference ) {
        if ( preference === 'dark' ) return 'dark';
        if ( preference === 'light' ) return 'light';
        return systemPrefersDark() ? 'dark' : 'light';
    }

    function readThemePreference() {
        try {
            const uid = localStorage.getItem( 'userId' );
            if ( uid ) {
                const scoped = localStorage.getItem( 'u:' + uid + ':theme' );
                if ( scoped === 'light' || scoped === 'dark' || scoped === 'system' ) return scoped;
            }
            const stored = localStorage.getItem( STORAGE_KEY );
            if ( stored === 'light' || stored === 'dark' || stored === 'system' ) return stored;
        } catch ( e ) { /* ignore */ }
        return 'system';
    }

    function getStoredPreference() {
        return readThemePreference();
    }

    function applyEffectiveTheme( preference ) {
        const pref = preference ?? getStoredPreference();
        const effective = resolveEffectiveTheme( pref );
        document.documentElement.setAttribute( 'data-theme', effective );
        document.documentElement.setAttribute( 'data-theme-pref', pref );
        return effective;
    }

    function setTheme( preference ) {
        try {
            localStorage.setItem( STORAGE_KEY, preference );
            const uid = localStorage.getItem( 'userId' );
            if ( uid ) localStorage.setItem( 'u:' + uid + ':theme', preference );
        } catch ( e ) { /* ignore */ }
        return applyEffectiveTheme( preference );
    }

    function toggleTheme() {
        const current = getStoredPreference();
        const next = current === 'dark' ? 'light' : 'dark';
        return setTheme( next );
    }

    window.applyThemeEarly = applyEffectiveTheme;
    window.getThemePreference = getStoredPreference;
    window.setTheme = setTheme;
    window.toggleTheme = toggleTheme;

    if ( window.matchMedia ) {
        window.matchMedia( '(prefers-color-scheme: dark)' ).addEventListener( 'change', () => {
            if ( getStoredPreference() === 'system' ) {
                applyEffectiveTheme( 'system' );
            }
        } );
    }
})();
